import { render, staticRenderFns } from "./vue-core-image-upload.vue?vue&type=template&id=6524d2b2&"
import script from "./vue-core-image-upload.vue?vue&type=script&lang=js&"
export * from "./vue-core-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./style/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports